<div class="ml-5 mr-5 flex h-full flex-1 flex-col">
  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="ag-theme-alpine mb-5 mt-5"
    [theme]="gridTheme"
    [rowClass]="rowCssClasses"
    [headerHeight]="60"
    [overlayNoRowsTemplate]="overlayNoRowsTemplate"
    [columnDefs]="columnDefs"
    [getRowId]="getRowId"
    [defaultColDef]="defaultColDef"
    [columnTypes]="columnTypes"
    [rowDragManaged]="true"
    [suppressColumnVirtualisation]="false"
    [rowDragMultiRow]="true"
    [suppressCellFocus]="true"
    [animateRows]="false"
    [rowSelection]="rowSelection"
    [getRowHeight]="getRowHeight.bind(this)"
    (rowClicked)="onRowClicked($event)"
    (selectionChanged)="onSelectionChanged($event)"
    (rangeSelectionChanged)="onRangeSelectionChanged($event)"
    (gridReady)="onGridReady($event)"
    (columnResized)="onColumnResized($event)"
    (rowDragEnd)="rowDragEndHandle($event)"
  ></ag-grid-angular>
</div>

<div *ngIf="report$ | async"></div>
